import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PREFERRED_SYSTEMS } from '@/common/constants';
import { useLelyAuth } from '@/auth/useLelyAuth';
import { setPreferredSystems } from '@/reducers/userDetailsSlice';
import { useGetAvailableSystemsQuery, System } from '@/rtk/availableSystemApi';

const usePreferredSystemsHydration = () => {
  const dispatch = useDispatch();
  const { user } = useLelyAuth();
  const { data: availableSystems = [] } = useGetAvailableSystemsQuery(
    undefined,
    {
      skip: !user?.allowltda,
      refetchOnMountOrArgChange: true,
    },
  );

  useEffect(() => {
    if (!user?.email || availableSystems.length === 0) return;

    const storageKey = `${PREFERRED_SYSTEMS}_${user.email}`;
    const storedSystems = localStorage.getObject(storageKey) as System[] | null;
    const hasStoredPreferredSystems =
      Array.isArray(storedSystems) && storedSystems.length > 0;

    if (hasStoredPreferredSystems) {
      dispatch(setPreferredSystems(storedSystems));
      return;
    }

    dispatch(setPreferredSystems(availableSystems));
    localStorage.setObject(storageKey, availableSystems);
  }, [dispatch, user?.email, availableSystems]);
};

export default usePreferredSystemsHydration;
